import React from 'react';
import { Form, Input, Modal, message, Select } from 'antd';
import { ONLY_HAS_H_B_H_LEVELS } from '@/constants';
import apis from '../../apis/index';
const { Option } = Select;
// import validator from '@/common/validator'
const ref = React.createRef();
export default class System extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      title: '申请信息完善',
      pin: '',
      monetizedLevel: '',
    };
  }

  handleOk = async () => {
    ref.current
      .validateFields()
      .then(async () => {
        const option = [];
        option.planCode = this.planCode;
        option.pin = this.state.pin ? this.state.pin : ref.current.getFieldsValue().pin;
        option.monetizedLevel = this.state.monetizedLevel
          ? this.state.monetizedLevel
          : ref.current.getFieldsValue().monetizedLevel;
        option.type = 1;
        const result = await apis.fetchmonetisePin(option);
        if (result.ret === '0') {
          this.handleApplyResource();
        } else {
          message.error(result.msg);
        }
      })
      .catch((ex) => {});
  };

  handleApplyResource = async () => {
    const option = [];
    option.planCode = this.planCode;
    option.resourceId = this.resourceId;
    const result = await apis.fetchResourceApply(option);
    if (result.ret === '0') {
      this.handleCancel();
      message.success('申请成功');
      this.props.onSuccess();
    } else {
      ref.current.resetFields();

      this.props.onFailed && this.props.onFailed();
      message.error(result.msg);
    }
  };

  handleCancel = (e) => {
    ref.current.resetFields();
    this.setState({
      visible: false,
    });
  };

  showModal = (planCode, resourceId, pin, monetizedLevel) => {
    this.planCode = planCode;
    this.resourceId = resourceId;
    this.setState({
      visible: true,
      pin: pin,
      monetizedLevel: monetizedLevel,
    });
  };

  componentDidMount() {}

  render() {
    return (
      <div className="card-container">
        <Modal
          title={this.state.title}
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          okText="提交"
          cancelText="取消"
        >
          <Form ref={ref} name="nest-messages" validateTrigger="onBlur">
            {this.state.pin ? null : (
              <Form.Item
                validateFirst
                name="pin"
                label="货币化PIN"
                rules={[
                  {
                    required: true,
                    message: '货币化pin不能为空',
                  },
                  {
                    max: 50,
                    message: '不超过50个字符！',
                  },
                  //  ,
                  //  {
                  //    validator: validator.validatePin(this.planCode, 1)
                  //  }
                ]}
              >
                <Input placeholder="请输入" />
              </Form.Item>
            )}
            {this.state.monetizedLevel ? null : (
              <Form.Item
                name="monetizedLevel"
                rules={[
                  {
                    required: true,
                    message: '货币化级别不能为空',
                  },
                ]}
                style={{ width: '280px' }}
                label="货币化级别"
              >
                <Select placeholder="请选择货币化级别" allowClear>
                  {ONLY_HAS_H_B_H_LEVELS.map((item) => (
                    <Option key={item.val} value={item.val}>
                      {item.title}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            )}
          </Form>
        </Modal>
      </div>
    );
  }
}
